import Top from "./top";
import Leaders from "./leaders";
import Grid from "./grid";

export const Dashboard = () => {
  return (
    <div className="main__article">
      <h1 className="onerow"><div><span>STAKING-</span></div><div><span>DASHBOARD</span></div></h1>
      <div className="dashboard__body">
        <Top></Top>
        <div style={{ paddingTop: '50px'}}>
           <Grid></Grid>
        </div>
        {/* <Leaders></Leaders> */}
      </div>
    </div>
  );
}

export default Dashboard;